import TopNavigationLayoutFullscreenContentWithLeftMenu from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutFullscreenContentWithLeftMenu'
import KnowleageBaseMenu from '../components/KnowleageBaseMenu'
import KnowleageBaseArticle from '../components/KnowleageBaseArticle'
import useFaqState from 'screens/Admin/KnowleageBase/hooks/useFaqState'
import useTreeLeafSelectCtrl from 'shared/Tree/ctrl/useTreeLeafSelectCtrl'

const KnowleagePage = () => {
  const { articles } = useFaqState()

  const treeSelectCtrl = useTreeLeafSelectCtrl('etb/student/faq', articles[0]?.id)

  const selectedArticle = articles.find(article => article.id === treeSelectCtrl.selectedItem)

  return (
    <TopNavigationLayoutFullscreenContentWithLeftMenu menu={<KnowleageBaseMenu treeSelectCtrl={treeSelectCtrl} />}>
      <KnowleageBaseArticle article={selectedArticle}/>
    </TopNavigationLayoutFullscreenContentWithLeftMenu>
  )
}

export default KnowleagePage
